export const config = {
  appLogs: [],
  appLink_port: 8800,
  requiredDevices: [],
  //Timeout block
  timeoutHostTransaction: 30, //fetch timeout in sec
  timeoutClosingRemark: 5,
  timeoutTakeCard: 3,
  timeoutTakeDocs: 3,
  timeoutDefault: 30,
  timeoutLong: 90,
  timeoutPopup: 15,
  timeoutError: 10,
  timeoutPleaseWait: 120,
  timeoutPrint: 30,

  heartbeatInterval: 300,

  // device timeouts
  platformConfig: {
      checkDeviceInterval: 30,
      checkDeviceIntervalActive: 60
  },

  //logs
  logConfig: {
      // max trace level to send to CUSSAppLink
      maxTraceLevelToSend: 5, // TraceLevels.LOG_TRACE
      //logMaxElementLength: 500,
      // max log message length to send to CUSSAppLink
      maxLogLthToSend: 2000,
      //logMemoryUsage: false,
      // also show logs in dev console
      logToConsole: true,
      addTimeToTrace: true
  },
  cussKioskId: 'CUSSTEST',
  smKioskId: 'SMTEST',
  airportCode: 'YYZ', // YYZ, FLL, AXM, PAP, LIM, LAX, CUN, PUJ
  location: 'PTY',
  defaultLoc: 'PTY',
  kiosk_type_config: 'KIOSK_TYPE',
  kioskId: 'KEKCTEST',

  showTestButton: false,
  testConsole: false,
  logToConsole: true,
  isCUSSRequired: true,
  pdfFormHeight: 11.1,
  pdfFormWidth: 4.5,
  pdfXMargin: 12,
  pdfPrintOptions: 'ORIENTATION=PORTRAIT,DARKNESS=10',
  bestShotTime: '<BestShotTime>3</BestShotTime>',

  // lighting definitions - ALERT in the first element indicates that CDS_APPLOG,ALERT, will be used instead of CDS_APPLOG,LIGHTING,AREA_APP_ZONE1,APP_PATTERN1
  lightsAvailable: true,
  kioskAvailable: [['ALERT', 'GREEN']],
  // timeoutPopup: [['ALERT', 'BLUE']],
  kioskInUse: [['ALERT', 'WHITE']],
  lightsTest: [['ALERT', 'APP_PATTERN1']],
  passportData: '',
  barcodeData: '',
  cardData: '',
  boardingPassResources: [],
  boardingPassPrintStream: [],
  bagtagPrintResources: [],
  bagtagPrintStream: [],
  epCMD: '',
  photoIx: 0,
  logMaxPCIElementLength: 0,
  kioskType: 0,
  etsInfo: 0,
};

//config.isCUSSRequired = false
config.showTestButton = true;

config.passportData = 'P<CANSMITH<<MARK<<<<<<<<<<<<<<<<<<<<<<<<<<<<_@AB123450<6CAN9801163M2204064<<<<<<<<<<<<<<00_@';
config.barcodeData =
  'M1BBB/BBB              RIWSGE LGAFLLNK 0779 122Y027A0001 147&gt;1184 K8122BNK 000000000000029487000000000030';
config.cardData = 'CACANTA00010509<00185978<<<<<5_@8705183F1409127IND<090912<00<4_@SPECIMEN<<LATIKA<YASMIN<<<<<<<_@';
config.boardingPassResources = [
  'PT##?Y1Z#@;#TICK #CHECK#BOARD#0101110112011301210122012301310132013301410142014301C#0413B32B56#0529C01#0807C30#09051128D#0A15D37#0C20D53#0D29E01#0E2011333302D#1009E31#1109E41#1201E51#1401F01#1517F03#160311021302D#1803F2011081308D#1905F2311111311D#1A02F2811161316D#1C05F3011181318D#1D04F363113D#2002F40#2201F53#2318F55#2401G01#2517G03#260311051305D#2703G20#2805G23#2902G28#2A05G30#2C04G35#2E02G40#3001G53#3118G55#3251H01#3436I01#3507I38#3607I45#3720I53#3819J01#3923J22#3A06J46#3B03J53#3C05J56#3D02J61#3E05J63#4004J69#4151K19F#4251L01#4505L54#4605L59#4705L65#4803L70#4911R01#4A09N63#4B12Q59#'
];
config.boardingPassPrintStream = [
  'TK#A#01Y#08Dec 1#09Dec 1#0CLum, Dylan#0DLum, Dylan#0ELum, Dylan#15Vancouver#16VAN#18240#19AG23#1A1#1CJan 1#1D201#23Vancouver#25Toronto#26TOR#31Toronto#3B240#3CAG23#3D1#3EJan 1#40201#453A#461200#474A#49Free#TK#1C01#',
  'TK#A#01Y#08Dec 1#09Dec 1#0CLum, Xylan#0DLum, Dylan#0ELum, Xylan#15Vancouver#16VAN#18240#19AG23#1A1#1CJan 1#1D201#23Vancouver#25Toronto#26TOR#31Toronto#3B240#3CAG23#3D1#3EJan 1#40201#453A#461200#474A#49Free#TK#1C01#'
];
config.bagtagPrintResources = [];
config.bagtagPrintStream = [];
config.epCMD = '#BHSTIMER=C3000';
config.photoIx = 0;
